"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoJSMetrics = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _StudioLogger = require("@studio/logger/StudioLogger");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var logger = new _StudioLogger.StudioLogger('VideoJSMetric');

/**
 * Hook to measure video playback metrics using Video.js player.
 * @param source
 * @param playerRef
 */
var useVideoJSMetrics = exports.useVideoJSMetrics = function useVideoJSMetrics(source, playerRef) {
  var _source$value;
  var player = playerRef.current;
  var startTime;
  var videoPlaying = false;
  var title = source.title,
    ext = source.ext,
    _id = source._id;
  var payload = {
    videoTitle: title,
    ext: ext,
    videoId: (_source$value = source.value) === null || _source$value === void 0 ? void 0 : _source$value.eventDocId
  };
  (0, _react.useEffect)(function () {
    if (!player) return;
    var lastPlayedQuality = null;
    startTime = performance.now();
    function getVideoDuration() {
      return Math.round(player.duration()) * 1000;
    }
    player.on('loadstart', function () {
      startTime = performance.now();
      logger.info("VideoJS - Starting to load", _objectSpread(_objectSpread({}, payload), {}, {
        videoDurationMs: getVideoDuration()
      }));
    });
    player.on('loadeddata', function () {
      var endTime = performance.now();
      var loadTime = endTime - startTime;
      logger.info("VideoJS - Time taken to load: ".concat(loadTime, " ms"), _objectSpread(_objectSpread({}, payload), {}, {
        videoLoadTime: loadTime,
        videoDurationMs: getVideoDuration()
      }));
    });
    player.on('playing', function () {
      if (!videoPlaying) {
        logger.info("VideoJS - Video Started Playing", _objectSpread(_objectSpread({}, payload), {}, {
          videoDurationMs: getVideoDuration()
        }));
        videoPlaying = true;
      }
    });
    player.on('timeupdate', function () {
      var width = player.videoWidth();
      var height = player.videoHeight();
      if (!width || !height) return;
      var quality = "".concat(width, "x").concat(height);
      if (quality !== lastPlayedQuality) {
        var _player$tech, _player$tech2, _navigator;
        var vhsStats = (_player$tech = player.tech({
          IWillNotUseThisInPlugins: true
        })) === null || _player$tech === void 0 || (_player$tech = _player$tech.vhs) === null || _player$tech === void 0 ? void 0 : _player$tech.stats;
        var throughput = (_player$tech2 = player.tech({
          IWillNotUseThisInPlugins: true
        })) === null || _player$tech2 === void 0 || (_player$tech2 = _player$tech2.vhs) === null || _player$tech2 === void 0 ? void 0 : _player$tech2.throughput;
        var networkInfo = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.connection;
        var stats = {
          bandwidth: vhsStats === null || vhsStats === void 0 ? void 0 : vhsStats.bandwidth,
          timeToLoadedData: vhsStats === null || vhsStats === void 0 ? void 0 : vhsStats.timeToLoadedData,
          throughput: throughput,
          networkDownlink: networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.downlink,
          networkEffectiveType: networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.effectiveType
        };
        lastPlayedQuality = quality;
        logger.info("VideoJS - Playback Quality: ".concat(quality), {
          sourceId: _id,
          width: width,
          height: height,
          name: title,
          videoDurationMs: getVideoDuration(),
          videoJsStats: stats
        });
      }
    });
    return function () {
      if (player) {
        player.off('loadstart');
        player.off('loadeddata');
        player.off('playing');
        player.off('timeupdate');
      }
    };
  }, [player]);
};